import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../base/request';
import { defaultSetting } from './default';
export const useDepositHistoryPageKey = (address, pageKey = '', pageSize = 500, enabled = false, p) => {
    const result = useQuery(['depositTxPageKey', address, pageKey, pageSize, p], async () => {
        return (await apiClient.get(`tx/getAssetTransferByAddress?address=${address}&pageSize=${pageSize}&pageKey=${pageKey}&type=deposit`)).data.data;
    }, {
        ...defaultSetting,
        enabled: !!address && enabled,
        staleTime: 1000 * 15,
        cacheTime: 1000 * 15,
        refetchInterval: 1000 * 15,
        keepPreviousData: false,
    });
    if (enabled === true) {
        return result;
    }
    else {
        return { data: null, isFetching: false };
    }
};
